import { Logging } from "@/data/util/Logging";
import { TypedSignal } from "@/data/util/Signal";

interface IFocusBackToWindowEvent {
    windowNotFocusedSeconds: number;
}

export class WindowFocusMonitor {
    public lastBlurTime?: Date;
    private focusHandler: any;
    private blurHandler: any;
    private secondsInactiveTreshold: number;

    public focusBackToWindow = new TypedSignal<IFocusBackToWindowEvent>();

    constructor(secondsInactiveTreshold: number = 0) {
        this.focusHandler = this.onFocus.bind(this);
        this.blurHandler = this.onBlur.bind(this);
        this.secondsInactiveTreshold = secondsInactiveTreshold;

        this.enable();
    }

    public enable() {
        window.addEventListener("focus", this.focusHandler);
        window.addEventListener("blur", this.blurHandler);
    }

    public disable() {
        if (this.focusHandler) {
            window.removeEventListener("focus", this.focusHandler);
        }

        if (this.blurHandler) {
            window.removeEventListener("blur", this.blurHandler);
        }
    }

    private async onFocus() {
        Logging.LogTrace("Window focus");

        const windowNotFocusedSeconds = this.getWindowNotFocusedSeconds();
        if (windowNotFocusedSeconds > this.secondsInactiveTreshold) {
            this.focusBackToWindow.dispatch({
                windowNotFocusedSeconds: windowNotFocusedSeconds,
            });
        }
    }

    private onBlur() {
        Logging.LogTrace("Window blur");

        this.lastBlurTime = new Date();
    }

    private getWindowNotFocusedSeconds() {
        const currentDate = new Date();
        const notFocusedMilliseconds = currentDate.getTime() - (this.lastBlurTime ?? currentDate).getTime();
        return notFocusedMilliseconds / 1000;
    }
}
